export const ADD_GROUPER = "ADD_GROUPER";
export const REMOVE_GROUPER= "REMOVE_GROUPER";
export const INITIAL_STATE= "INITIAL_STATE";